import R from 'ramda'

const COMMENTS_ON_DISPLAY_TYPE = 'Comments On Post'
const EXISTING_POST_TRIGGER_TYPES = ['FB_INITIAL_POST', 'COMMENTS_ON']

const hasValidTriggerType = R.flip(R.contains)
const isCommentsOnWidgetTrigger = R.pipe(
  R.prop('type'),
  hasValidTriggerType(EXISTING_POST_TRIGGER_TYPES)
)

const constructExistingPostFormData = R.applySpec({
  type: R.always(COMMENTS_ON_DISPLAY_TYPE),
  action: R.always('EXISTING_POST'),
  value: R.prop('data')
})

const isExistingPost = R.propEq('type', 'COMMENTS_ON')
const isPlainTextInitialPost = R.pathSatisfies(R.equals('text'), [
  'data',
  'type'
])
const isImageInitialPost = R.pathSatisfies(R.equals('image'), ['data', 'type'])
const isVideoInitialPost = R.pathSatisfies(R.equals('video'), ['data', 'type'])

const constructNewTextPostFormData = R.applySpec({
  type: R.always(COMMENTS_ON_DISPLAY_TYPE),
  action: R.always('NEW_POST_TEXT'),
  postText: R.path(['data', 'searchParams', 'message'])
})

const constructNewImagePostFormData = R.applySpec({
  type: R.always(COMMENTS_ON_DISPLAY_TYPE),
  action: R.always('NEW_POST_IMAGE'),
  postText: R.path(['data', 'searchParams', 'message']),
  imageUrl: R.path(['data', 'searchParams', 'url'])
})

const constructNewVideoPostFormData = R.applySpec({
  type: R.always(COMMENTS_ON_DISPLAY_TYPE),
  action: R.always('NEW_POST_VIDEO'),
  postText: R.path(['data', 'searchParams', 'description']),
  videoUrl: R.path(['data', 'searchParams', 'file_url'])
})

const convertCommentsOnWidgetTriggerToFormTrigger = R.cond([
  [isExistingPost, constructExistingPostFormData],
  [isPlainTextInitialPost, constructNewTextPostFormData],
  [isImageInitialPost, constructNewImagePostFormData],
  [isVideoInitialPost, constructNewVideoPostFormData]
])

export {
  isCommentsOnWidgetTrigger,
  convertCommentsOnWidgetTriggerToFormTrigger
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/facebook/widget-to-form/comments-on.js